import 'css-chunksrc/client/scenes/constraintRemoval/styles.scss';export default {
  "header": "_header_mgzj4_1",
  "message": "_message_mgzj4_5",
  "name": "_name_mgzj4_10",
  "main": "_main_mgzj4_14",
  "buttons": "_buttons_mgzj4_21"
};